import { Layout } from '@taxdown/piccolo-web';
import styled from 'styled-components';

export const ListContainer = styled(Layout.Grid)<{ $items: number }>`
  grid-auto-flow: column;
  grid-template-rows: repeat(3, auto);
  grid-template-columns: ${({ $items }) =>
    $items.length > 3 ? 'repeat(2, 1fr)' : 'repeat(1, 1fr)'};
  column-gap: ${({ $items, theme: { reference } }) => $items > 3 && reference.dimension_08};
`;
